"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var styles_1 = require("./styles");

var Dropdown_1 = require("./Dropdown");

function LinkDropdown(props) {
  var children = props.links.map(function (link, index) {
    return React.createElement("div", __assign({}, styles_1.dropdownItemStyle, {
      key: index
    }), React.createElement("a", __assign({
      href: link.url
    }, styles_1.dropdownLinkStyle, font_1.regular), link.name));
  });
  return React.createElement(Dropdown_1.Dropdown, __assign({}, props, {
    minContentWidth: 226
  }), children);
}

exports.LinkDropdown = LinkDropdown;